export const ROOT = '/'
export const SIGN_IN = '/sign-in'
export const SSO = '/sso'
export const SSO_ERROR = '/sso-error'

export const CARE_PLANS_PATH = '/care-plans'
export const CARE_PLAN_PATH = '/care-plans/:id'
export const BUILD_CARE_PLAN_PATH = '/build-care-plan'
export const BUILD_CARE_PLAN_ID_PATH = '/build-care-plan/:id'
export const SUBMIT_CARE_PLAN_ID_PATH = '/submit-care-plan/:id'
export const ADVOCATE_PROFILES_PATH = '/user-profiles'
export const ADVOCATE_PROFILE_EXTERNAL_PROFILE_PATH = '/user-profiles/:id'
export const ADVOCATE_PROFILE_MY_PROFILE_PATH = '/my-profile'
export const MEMBERS_PATH = '/members'
export const MEMBER_PATH = '/members/:id'
export const PROVIDERS_PATH = '/providers'
export const FACILITIES_PATH = '/facilities'
export const ORGANIZATION_GROUPS_PATH = '/organization-groups'
export const THIRD_PARTY_ADMINS_PATH = '/partnerships'
export const THIRD_PARTY_ADMIN_PATH = '/partnerships/:id'
export const INVITES_PATH = '/invites'
export const TEAMS_PATH = '/teams'
export const LIBRARY_PATH = '/library'
export const LIBRARY_ARTICLE_CREATE_PATH = '/library/create-new'
export const LIBRARY_ARTICLE_PATH = '/library/:id'
export const LIBRARY_ARTICLE_EDIT_PATH = '/library/:id/edit'
export const ARTICLE_CATEGORIES_PATH = '/article-categories'
export const PERMISSION_AUDIT_LOGS_PATH = '/permission-audit-logs'
export const QUEUE_SYSTEM_AUDIT_LOGS_PATH = '/queue-system-audit-logs'
export const QUEUES_PATH = '/queues'
export const QUEUE_PATH = '/queues/:id'
export const INTAKE_GROUPS_PATH = '/intake-groups'
export const INTAKE_GROUP_PATH = '/intake-groups/:id'
export const QUEUE_SYSTEM_SETTINGS_PATH = '/queue-system-settings'

export const HIPAA_PATH = '/hipaa'
export const BENEFITS_CMS_PATH = '/benefits-cms'
export const PHARMACY_PLAN_PATH = '/pharmacy-plans/:id'
export const PHARMACY_PLANS_PATH = '/pharmacy-plans'
export const TASKS_PATH = '/tasks'
export const TICKETS_PATH = '/tickets'
export const AI_PATH = '/ai'
export const NIC_REDIRECT_PATH = '/nic-redirect'

export const TICKET_SETTINGS_PATH = '/ticket-settings'
export const SURVEYS_PATH = '/surveys'
export const BENEFIT_CMS_SETTINGS_PATH = '/benefit-cms-settings'
export const CARE_PODS_PATH = '/care-pods'
export const CARE_POD_DETAILS_PATH = '/care-pods/:id'

export const EXTRA_ROUTES = [ROOT, SIGN_IN, SSO, SSO_ERROR, HIPAA_PATH]
